import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from 'config/axiosInstance';
import { ACCESS_TOKEN } from 'config/keywords';
import true_icon from '../../../../assets/icons/true.svg';
import false_icon from '../../../../assets/icons/false.svg';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

const DriverHealthCheckDetails: React.FC = () => {
  const { t, i18n } = useTranslation('driver');
  const { id } = useParams<{ id: string }>();
  const [healthCheckDetails, setHealthCheckDetails] = useState<any>(null);

  const fetchHealthCheckDetails = useCallback(async () => {
    const accessToken = localStorage.getItem(ACCESS_TOKEN);
    if (!accessToken) {
      console.error('No access token available');
      return;
    }

    try {
      const response = await axiosInstance.get(
        `/v1/health_inspection_records/${id}/`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      setHealthCheckDetails(response.data);
    } catch (error) {
      console.error('Failed to fetch health check details', error);
    }
  }, [id]);

  useEffect(() => {
    fetchHealthCheckDetails();
  }, [fetchHealthCheckDetails]);

  if (!healthCheckDetails) {
    return <div>Loading...</div>;
  }

  return (
    <section className="p-4 bg-gray-100">
      <div className="flex flex-row mb-4 text-primary/300 font-semi-bold text-subtitle-2 items-center space-x-4">
        <p>{healthCheckDetails.id}</p>
        <MdKeyboardArrowRight size={24} />
        <p>{t('view.health-check.title')}</p>
        <MdKeyboardArrowRight size={24} />
        <p className="underline">{t('inspection-record.detail_button')}</p>
      </div>
      <div className="mb-4 bg-white shadow-md rounded-lg p-4">
        <div className="grid grid-cols-4 gap-4">
          <div>
            <p className="font-semibold">
              {t('view.health-check.health-check-detail.status-date')}
            </p>
            <p>
              {new Date(healthCheckDetails.create_time).toLocaleDateString()}
            </p>
          </div>
          <div>
            <p className="font-semibold">
              {t('view.health-check.health-check-detail.status-driver-name')}
            </p>
            <p>{healthCheckDetails.user.name}</p>
          </div>
          <div>
            <p className="font-semibold">
              {t('view.health-check.health-check-detail.status-maintenance')}
            </p>
            <p>{healthCheckDetails.maintenance_manager}</p>
          </div>
          <div>
            <p className="font-semibold">
              {t('view.health-check.health-check-detail.status-operation')}
            </p>
            <p>{healthCheckDetails.operations_manager}</p>
          </div>
        </div>
      </div>
      <div className="bg-white shadow-md rounded-lg p-4">
        <table className="w-full table-auto border-collapse">
          <thead>
            <tr className="bg-gray-200">
              <th className="border px-4 py-2 text-left">
                {t('view.health-check.health-check-detail.question')}
              </th>
              <th className="border px-4 py-2 text-left">
                {t('view.health-check.health-check-detail.answer')}
              </th>
              <th className="border px-4 py-2 text-left">
                {t('view.health-check.health-check-detail.note')}
              </th>
            </tr>
          </thead>
          <tbody>
            {healthCheckDetails.details.driver_healthcheck[0].item.map(
              (item: any, index: number) => (
                <tr key={index} className="border-b">
                  <td className=" px-4 py-2">{item.name}</td>
                  <td className=" px-4 py-2 text-center">
                    {item.status ? (
                      <img src={true_icon} alt="" />
                    ) : (
                      <img src={false_icon} alt="" />
                    )}
                  </td>
                  <td className=" px-4 py-2">{item.note || '-'}</td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default DriverHealthCheckDetails;
